import React from 'react';
import DemoCard from '../components/DemoCard';
import './HomePage.css';

const demos = [
  {
    title: 'Real Estate',
    description: 'Property listing platform with advanced filters, mortgage calculator, image carousel, agent contact, and grid/list views.',
    icon: '🏠',
    route: '/demo/real-estate',
    tags: ['Filters', 'Calculator', 'Responsive'],
    status: 'live',
  },
  {
    title: 'Games Arcade',
    description: '6 interactive games — 2048, Slide Puzzle, Memory Match, Snake, Wordle, and Tic-Tac-Toe with AI. All with animations and mobile support.',
    icon: '🎮',
    route: '/demo/games',
    tags: ['Games', '6 Games', 'AI Opponent'],
    status: 'live',
  },
  {
    title: 'Task Manager',
    description: 'A beautiful Kanban-style task management app with drag-and-drop, labels, and priority levels. Perfect for project tracking.',
    icon: '📋',
    route: '/demo/task-manager',
    tags: ['React', 'Drag & Drop', 'LocalStorage'],
    status: 'live',
  },
  {
    title: 'Weather Dashboard',
    description: 'Real-time weather dashboard with interactive charts, forecasts, and location search. Clean data visualization.',
    icon: '🌦️',
    route: '/demo/weather',
    tags: ['Charts', 'API', 'Responsive'],
    status: 'live',
  },
  {
    title: 'E-Commerce Store',
    description: 'Modern shopping experience with product catalog, cart functionality, filters, and a sleek checkout flow.',
    icon: '🛒',
    route: '/demo/ecommerce',
    tags: ['Cart', 'Filters', 'Animations'],
    status: 'live',
  },
  {
    title: 'Chat Application',
    description: 'Real-time messaging interface with typing indicators, read receipts, emoji support, and conversation threads.',
    icon: '💬',
    route: '/demo/chat',
    tags: ['WebSocket', 'Real-time', 'UI/UX'],
    status: 'live',
  },
  {
    title: 'Analytics Dashboard',
    description: 'Data-rich analytics dashboard with multiple chart types, date range filtering, and exportable reports.',
    icon: '📊',
    route: '/demo/analytics',
    tags: ['Charts', 'Data Viz', 'Responsive'],
    status: 'live',
  },
  {
    title: 'Social Media Feed',
    description: 'Instagram-style social feed with infinite scroll, like/comment interactions, stories, and image galleries.',
    icon: '📱',
    route: '/demo/social-feed',
    tags: ['Infinite Scroll', 'Interactions', 'Media'],
    status: 'live',
  },
  {
    title: 'AI Studio',
    description: 'Multi-model AI dashboard with chat, image generation, prompt templates, model comparison, and usage analytics.',
    icon: '🤖',
    route: '/demo/ai-dashboard',
    tags: ['AI/ML', 'Chat', 'Dashboard'],
    status: 'live',
  },
];

function HomePage() {
  return (
    <div className="home">
      <section className="hero">
        <div className="hero-bg">
          <div className="hero-orbs-ring">
            <div className="hero-orb orb-1"></div>
            <div className="hero-orb orb-2"></div>
            <div className="hero-orb orb-3"></div>
          </div>
        </div>
        <div className="hero-content">
          <div className="hero-badge">Frontend Developer Portfolio</div>
          <h1 className="hero-title">
            Crafting <span className="gradient-text">Beautiful</span> Digital Experiences
          </h1>
          <p className="hero-subtitle">
            Explore interactive demo applications built with React.js — showcasing modern UI/UX design,
            clean code architecture, and pixel-perfect implementations.
          </p>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">{demos.length}</span>
              <span className="stat-label">Demo Apps</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat">
              <span className="stat-number">React</span>
              <span className="stat-label">Framework</span>
            </div>
            <div className="stat-divider"></div>
            <div className="stat">
              <span className="stat-number">100%</span>
              <span className="stat-label">Frontend</span>
            </div>
          </div>
        </div>
      </section>

      <section className="demos-section">
        <div className="section-header">
          <h2 className="section-title">Demo Applications</h2>
          <p className="section-subtitle">Click on any card to explore the live demo</p>
        </div>
        <div className="demos-grid">
          {demos.map((demo, index) => (
            <DemoCard key={index} {...demo} />
          ))}
        </div>
      </section>

      <footer className="footer">
        <p>Built with React.js &bull; Designed by Nipun W</p>
      </footer>
    </div>
  );
}

export default HomePage;
